export default __webpack_public_path__ + "static/appl-logo-0f58cfbc9706e072673976a087e923bd.png";